import * as React from "react";
import classnames from "classnames";
import { useEffect, useState } from "react";
import { IInputType } from "./formFields";

export interface IInput {
    config: IInputType;
    onChange: CallableFunction;
    validate: number;
    onValidate: (isValid: boolean) => void;
    reset: number;
    defaultValue?: any;
}

export const Input = ({ config, reset, onChange, validate, onValidate, defaultValue }: IInput): JSX.Element => {
    const [value, setValue] = useState("");
    const [valid, setValid] = useState<boolean>(true);

    const changeValue = (e: React.ChangeEvent<HTMLInputElement>) => {
        setValue(e.target.value);
        setValid(true);
        onChange(e);
    };

    useEffect(() => {
        if (validate === 0) {
            setValid(true);
        } else {
            const isValid =
                !config.required && !value
                    ? true
                    : config.required && !value
                    ? false
                    : config.validationFn
                    ? config.validationFn(value)
                    : true;
            setValid(isValid);
            onValidate(isValid);
        }
    }, [validate]);

    useEffect(() => {
        setValue("");
    }, [reset]);

    useEffect(() => {
        defaultValue && !value && setValue(defaultValue);
    }, [defaultValue]);

    return (
        <div className={classnames("form-field", { invalid: !valid })}>
            <div className="field-input">
                <label htmlFor={config.name} className={classnames("input-label", { required: config.required })}>
                    {config.label}
                </label>
                <input
                    className="input-element"
                    id={config.name}
                    name={config.name}
                    type={config.type}
                    autoComplete={config.autocomplete || "off"}
                    required={config.required || false}
                    value={value}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => changeValue(e)}
                />
            </div>
            {!valid ? <span className="field-validation">{config.validationErrorMessage || "Kļūda!"}</span> : null}
        </div>
    );
};
